import I18N from '@/src/app/_i18n/i18nConfig.ts'
import { SupportedLangsType } from '@/src/app/_i18n/settings.tsx'

export type PrismicLangType =
  (typeof I18N.i18n.mapPrimsicToNext)[keyof typeof I18N.i18n.mapPrimsicToNext]

export const getPrismicLang = (
  lang: SupportedLangsType | '*',
): PrismicLangType => I18N.i18n.mapPrimsicToNext[lang]
